export default {
  title: {
    name: "美信小程序",
  },
  mxTitle: '美信',
  mxHarmonyTitle: '美信Harmonyの内部テスト版',
  mxLongContent: 'あなたと共に成長',
  locale: '日本語',
  problem: 'よくある質問',
  help: 'フィードバック',
  welcome: "欢迎",
  downloadNow: 'ダウンロード',
  netError: 'ネットワーク異常、後で再試行してください',
  codeLargeTip: '（ダウンロード用のQRコードをクリックして拡大表示することができます。）',
  ok: '了解しました',
  clickRightTopIOS: '右上をクリックして、「safari」で開く',
  clickRightTopAndroid: '右上のメニューをクリックし、ブラウザで開きます',
  toProblem: '_problem-ja',
  mideaConnect: 'MideaConnect は企業アプリケーションであるため、初回インストール後にアプリケーション証明書を信頼する必要があります。携帯電話の 設定 > 一般 > VPNとデバイス管理 > Midea Group Co.,Ltd を開き、信頼をクリックしてください。',
  phoneSuccessTips: '「インストール」をクリックすると、デスクトップに戻ってインストールの様子を見ることができます',
  mx: {
    introduce: '美信は、従業員間のやり取りを活性化し、生産性を高めるため、Mideaグループが自社開発したコミュニケーションツールです。グループチャット、ファイル共有、ビデオ会議、ミニプログラム等、様々な機能が搭載し、コミュニケーションやチームワークの向上をサポートします。',
    downTips: '美信クライアントをダウンロード',
    ios: 'iOS',
    android: 'Android & HarmonyOS\n(HarmonyOS 5.0を含まない)',
    harmony: 'HarmonyNext\n(Harmony Next)',
    mac: 'macOS',
    window: 'Windows',
    downloadClick: 'クリック',
    downloadScan: 'スキャン',
    scanCodeDown: 'QRコードをスキャンして、ダウンロード',
    harmonyScan: '美信を使ってQRコードをスキャンしてグループに参加し、ダウンロードするか、または美信 - 検索で下記のグループ番号を入力してグループに参加できます:',
    copySuccess: 'コピーに成功しました',
    copyErrorTitle: 'コピー失敗',
    copyError: '1.ブラウザの権限設定を確認し、クリップボードへの書き込み権限があることを確認してください;\n2.ブラウザがコピーをサポートしていない可能性があります。別のブラウザを使用してみてください.',
    mobile_harmonyScan: '美信のアプリを起動し、スキャン機能を使ってグループに参加し、コンテンツをダウンロードできます',
    mobile_joinGroup: 'グループに参加するには、美信アプリを使用し、提供されたグループ番号を検索バーに入力してください:',
    mobile_getHarmony: 'ネイティブのHarmonyNextバージョンを取得します',
    mobile_getHarmonyBeta: 'HarmonyNext ベータ版を取得する',
  },
  vpn: {
    title: '美的VPN',
    introduce: 'VPNは、美的グループが内部で使用するネットワークツールで、在宅勤務や出張などのリモートワークシナリオで従業員を支援し、作業効率を向上させることができます。',
    tips: '長押ししてアルバムに保存するか、QRコードをスキャンしてダウンロードします。',
    downTips: 'ダウンロードVPN',
    configureSeq: 'インストールガイド',
    configureDownload: '設定ファイル',
    pcCoreAliens: '中国の海外版に切り替えます',
    pcCoreZH: '中国の国内版に切り替えます',
    iphoneCoreAliens: '海外版ダウンロード ',
    iphoneCoreZH: '中国国内版ダウンロード',
    downloadAliens: 'スキャン',
    downloadZH: 'スキャン',
  },
  MacDownload: {
    title: 'Macに最適なMidea Connectのバージョンをダウンロードする',
    text1: 'Midea Connectは、Intelチップを搭載したMacコンピュータとAppleチップを搭載したMacコンピュータの両方に最適化されています。正しいバージョンを使用することで、リソース消費を減らし、ソフトウェアのパフォーマンスを向上させることができます',
    text2: 'Macコンピュータのチップタイプを確認する方法は？',
    "text2-intel": 'お使いのコンピュータのチップがIntelであることを検出しました。Intelチップバージョンの美信をお勧めします',
    "text2-apple": 'お使いのコンピュータのチップがAppleであることを検出しました。Appleチップバージョンの美信をお勧めします',
    text3: '',
    text4: '*チップバージョンを確認できない場合は、直接Intelバージョンをダウンロードできます',
    macIntel: 'Intelチップバージョンをダウンロードする',
    macM1: 'Appleチップバージョンをダウンロードする',
    aboutLeft: '1. 左上のAppleメニューをクリックし、',
    about: '「このMacについて」',
    aboutRight: 'を選択します',
    gaishuLeft: '2. ',
    gaishu: '概要',
    chuliqiLeft: 'ページの',
    chuliqi: 'プロセッサ',
    typeLeft: '列で、',
    type: 'チップタイプ',
    intelLeft: 'が',
    intel: '「Intel」',
    appleLeft: 'または',
    apple: '「Apple」',
    appleRight: 'であるかどうかを確認し、対応するバージョンをダウンロードします',
    img1: require('../assets/M1/img1_ja.png'),
    img2: require('../assets/M1/img2_ja.png'),
    img3: require('../assets/M1/img3_ja.png'),
  }
};
